<template>
  <div class="workcenter-metric" :class="borderClass">
    <div class="workcenter-metric__title" @click="toggleDropdown">
      <span>{{ title }}</span>
      <i v-if="options.length" class="bx bx-chevron-down workcenter-metric__chevron"></i>
    </div>
    <div class="workcenter-metric__body">
      <span class="workcenter-metric__value" :class="valueClass">{{ value }}</span>
      <span v-if="suffix" class="workcenter-metric__suffix">{{ suffix }}</span>
      <span v-if="badge" class="workcenter-metric__badge" :class="badgeClass">{{ badge }}</span>
    </div>
    <div v-if="isOpen && options.length" class="workcenter-metric__dropdown">
      <div class="workcenter-metric__dropdown-title">Select Metric</div>
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="workcenter-metric__option"
        :class="{'workcenter-metric__option--active': option.value === selectedValue}"
        @click.stop="selectOption(option)"
      >
        <span>{{ option.label }}</span>
        <i v-if="option.value === selectedValue" class="bx bx-check"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkcenterMetricWidget',
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: 0 },
    suffix: { type: String, default: '' },
    badge: { type: String, default: '' },
    color: { type: String, default: 'brand' },
    options: { type: Array, default: () => [] },
    selectedValue: { type: [String, Number], default: null }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    borderClass() {
      return 'workcenter-metric--' + this.color
    },
    valueClass() {
      return this.color === 'red' ? 'workcenter-metric__value--red' : ''
    },
    badgeClass() {
      return this.color === 'red' ? 'workcenter-metric__badge--red' : 'workcenter-metric__badge--brand'
    }
  },
  methods: {
    toggleDropdown() {
      if (!this.options.length) {
        return
      }
      this.isOpen = !this.isOpen
    },
    selectOption(option) {
      this.isOpen = false
      this.$emit('select', option)
    }
  }
}
</script>
